import Modal from '@/js/plugins/Modal';

/**
 * 採用ページ 先輩社員インタビュー モーダル
 * data-interview-modal属性に指定されたIDのテンプレートを複製して表示する
 */
const recruitInterviewModal = () => {
    if (!document.querySelector('[data-interview-modal]')) return;

    const modal = new Modal({
        modifierClass: 'plugin-modal--recruit-interview',
    });

    // SPのSwiper(loop)が複製したスライドでも動くようにデリゲーションで拾う
    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-interview-modal]');
        if (!trigger) return;

        e.preventDefault();
        const template = document.getElementById(trigger.dataset.interviewModal);
        if (!template) return;

        // 閉じるとModal側でDOMごと破棄されるため、複製を渡して元テンプレートを残す
        const dom = template.cloneNode(true);
        dom.removeAttribute('id');
        dom.hidden = false;
        modal.setDom(dom).show();
    });
};

export default recruitInterviewModal;
